import React, { useEffect, useState, useRef } from "react";
import styles from "../topology.module.scss";
import { Table } from "antd";
import { VariableSizeGrid as Grid } from "react-window";
import ResizeObserver from "rc-resize-observer";

const VirtualTable = React.memo((props: any) => {
  const { columns, scroll, setCenterPosition, SelectedIndex, setCurrentZoom, setCoordinate, setSelectedIndex } = props;
  const [tableWidth, setTableWidth] = useState(0);
  const widthColumnCount = columns.filter(({ width }: any) => !width).length;
  const mergedColumns = columns.map((column: any) => {
    if (column.width) {
      return column;
    }

    return { ...column, width: Math.floor(tableWidth / widthColumnCount) };
  });

  const gridRef = useRef<any>();
  const [connectObject] = useState<any>(() => {
    const obj = {};
    Object.defineProperty(obj, "scrollLeft", {
      get: () => null,
      set: (scrollLeft: number) => {
        if (gridRef.current) {
          gridRef.current.scrollTo({
            scrollLeft,
          });
        }
      },
    });
    return obj;
  });

  const resetVirtualGrid = () => {
    gridRef.current.resetAfterIndices({
      columnIndex: 0,
      shouldForceUpdate: false,
    });
  };

  useEffect(() => resetVirtualGrid, [tableWidth]);
  //rawData官方型別: object[]
  const renderVirtualList = (rawData: any, { scrollbarSize, ref, onScroll }: any) => {
    ref.current = connectObject;
    const totalHeight = rawData.length * 54;
    return (
      <Grid
        ref={gridRef}
        className="virtual-grid"
        columnCount={mergedColumns.length}
        columnWidth={(index: number) => {
          const { width } = mergedColumns[index];
          return totalHeight > scroll.y && index === mergedColumns.length - 1
            ? (width as number) - scrollbarSize - 1
            : (width as number);
        }}
        height={scroll!.y as number}
        rowCount={rawData.length}
        rowHeight={() => 54}
        width={tableWidth}
        onScroll={({ scrollLeft }: { scrollLeft: number }) => {
          onScroll({
            scrollLeft,
          });
        }}
      >
        {({ columnIndex, rowIndex, style }: { columnIndex: number; rowIndex: number; style: React.CSSProperties }) => (
          <div
            className={` ${rowIndex === SelectedIndex ? `${styles.rowClass} ${styles.rowbase}` : styles.rowbase}`}
            style={style}
            onClick={() => {
              setCenterPosition([rawData[rowIndex].lat, rawData[rowIndex].log]);
              setSelectedIndex(rowIndex);
              setCurrentZoom(17);
              setCoordinate([
                [
                  `${new Date(rawData[rowIndex].readableTime)}`,
                  rawData[rowIndex].lat,
                  rawData[rowIndex].log,
                  rawData[rowIndex].alt,
                ],
              ]);
            }}
          >
            {rawData[rowIndex][mergedColumns[columnIndex].dataIndex]}
          </div>
        )}
      </Grid>
    );
  };

  return (
    <ResizeObserver
      onResize={({ width }) => {
        setTableWidth(width);
      }}
    >
      <Table
        {...props}
        className="virtual-table"
        columns={mergedColumns}
        pagination={false}
        components={{
          body: renderVirtualList,
        }}
      />
    </ResizeObserver>
  );
});

export default VirtualTable;
